import {Injectable} from '@angular/core';
import {AResourceService} from "./a-resource.service";
import {CountryModel} from "../../models/resources/country.model";
import {LanguageService} from "./language.service";
import {UrlParamModel} from "../../models/url-param.model";

@Injectable({
  providedIn: 'root',
})
export class CountryService extends AResourceService<CountryModel> {
  constructor(private languageService: LanguageService) {
    super('/countries', false);
  }

  protected override getDefaultListParams(): UrlParamModel[] {
    const code = this.languageService.activeLanguage()?.code;
    if (!code) {
      return [];
    }
    return [{key: 'lang', value: code}];
  }
}
